import React from 'react';
import { useSelector } from 'react-redux';
import { getCountryCode, getFlagUrl } from '../../../SysGuard/Dashboard/ContentPages/SysGuardColumnConfig';

/**
 * Common header component for user location popups
 */
const UserLocationHeader = ({ 
  popupData, 
  location, 
  isIncognito = false,
  title = "Location - Users",
  subHeading = "Activities:",
  showCountryFlag = true
}) => {

  const popupDetails = useSelector((state) => state.DataguardReducer.popupDetails);
  const renderCountryNameWithFlag = (country) => {
    const code = getCountryCode(country);
    let flagUrl = "/sysGuardIcons/unknownFlag.svg";
    if (code && code !== "Unknown" && code !== "Not Found") {
      flagUrl = getFlagUrl(code);
    }
    return (
      <>
        {flagUrl && country !== "Unknown" ? (
          <div className="country-with-flag">
            <img src={flagUrl} alt={country} className="country-flag Title" />
            <span className="second-title">{country}</span>
          </div>
        ) : (
          <div className="country-with-flag">
            <img src={"/sysGuardIcons/unknownFlag.svg"} alt={"Unknown"} className="country-flag Title" />
            <span className="second-title">{country}</span>
          </div>
        )}
      </>
    );
  };

  const renderTitleNumberClasses = () => {
    return "sys-guard-location nonAnomalies";
  };

  const renderTitleNumber = (popupData) => popupData?.totalElements ?? 0;

  return (
    <div className="user-location-left-panel">
      <div className="header-title">{title}</div>
      <div className="second-title-container">
        {showCountryFlag ? (
          renderCountryNameWithFlag(location)
        ) : (
          <span className="second-title">{popupDetails?.subtitleDisplayName || ''}</span>
        )}
        <span className="header-title"> {`( `} </span>
        <span className={renderTitleNumberClasses()}>
          {subHeading} {renderTitleNumber(popupData)}
        </span>
        <span className="header-title">)</span>
      </div>
    </div>
  );
};

export default UserLocationHeader;